/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum Platform {
  Android = 'Android',
  IOs = 'iOS'
}
